import cityData from '@/data/kuaishou/city_province.json'
import { isArray, deepCopy, timeout, getKeyOfData } from '@/common/js/utils'
import { getPopulationList } from '@/api/kuaishou.model'

const defaulTargetParams = {
  // 定向
  intelli_extend_option: 0, // 是否开启智能定向
  gender: 0, // 性别默认不限
  region: [], // 地域ID列表
  age: [25, 45], // 年龄
  platform_os: 1, // 系统版本
  android_osv: 3, // 安卓版本
  ios_osv: 6, // iOS版本
  device_brand_ids: 0, // 设备品牌
  device_price: 0, // 设备价格
  network: 0, // 网络
  app_interest_ids: [], // APP行为-按分类
  app_ids: [], // APP行为-按应用
  filter_converted_level: 0, // 过滤已转化
  exclude_population: [], // 定向人群包
  population: [], // 排除人群包
  behavior_type: 0, // 行为兴趣定向
  action_tags: [],
  action_scene: [1, 2, 4],
  action_days: 4,
  action_intensity: 0,
  interest_intensity: 0,
  word_tags: [],

  // 辅助参数
  district: 'NONE',
  ageMode: 'NONE',
  audienceMode: 'NONE',
  mult_cate: [], // 选择的app名称
  categroyData: [],
  app_behavior: 0
}

export default {
  data() {
    return {
      show: null,
      cityData,
      audienceData: [],
      appData: [],
      originAppData: [],
      audiences: [{}],
      behaviorAndInterest: {}
    }
  },
  computed: {
    originData() {
      return {
        cityData: this.cityData,
        appData: this.appData,
        audiences: this.audiences,
        audienceData: this.audienceData
      }
    }
  },
  methods: {
    // 切换定向
    setTargeter(index) {
      const item = this.targetPlan[index]
      this.targetPlan.forEach((ret) => {
        this.$set(ret, 'check', false)
      })
      this.$set(item, 'check', true)
      timeout(100).then(() => {
        if (this.$refs.selectTarget && this.$refs.selectTarget[0]) {
          const { $refs } = this.$refs.selectTarget[0]
          $refs && $refs.barContent && ($refs.barContent.scrollLeft = 2800)
        }
        this.show = true
      })
    },
    delTargeter(index) {
      const idx = this.targetPlan.findIndex((ret) => ret.check)
      const len = this.targetPlan.length
      if (len < 2) {
        this.$Message.error({
          closable: true,
          duration: 5,
          content: '不能删除最后一个定向'
        })
        return
      }
      // 删除自己
      if (index === idx) {
        if (index > 0) this.setTargeter(index - 1)
        else this.setTargeter(1)
      }
      this.targetPlan.splice(index, 1)
    },
    appendTargeter(target) {
      console.log('targettargettarget output: ', target)
      const len = this.targetPlan.length
      if (isArray(target)) {
        if (target.length > 10 - len) {
          const idx = target.length - (10 - len)
          target.splice(-idx, idx)
        }
        // 选择定向
        target.map((ret, idx) => {
          const { targetingId, targetingName, targetingParamJson } = ret
          const { audiences } = targetingParamJson
          const originData = deepCopy(this.originData)
          if (audiences) {
            // 参数存在为自定义定向包
            // 参数跨账号处理
            this.selectAudience(audiences, originData, targetingParamJson)
            delete targetingParamJson.audiences
            // 合并所有定向参数
            this.$set(target, idx, {
              targetingId: targetingId,
              targetingName: targetingName,
              targetingParam: Object.assign(originData, targetingParamJson)
            })
          } else {
            // 系统定向包处理
            const sysTarget = Object.assign({}, defaulTargetParams, originData, targetingParamJson)
            this.convertSysTargetParams(sysTarget)
            this.$set(target, idx, {
              targetingId: targetingId,
              targetingName: targetingName,
              targetingParam: Object.assign({}, defaulTargetParams, sysTarget)
            })
          }
        })
        // 全自动投放时，只能选择一个定向
        if (this.deliveryMethod === 3) {
          this.targetPlan = target
        } else this.targetPlan.push(...target)
        this.setTargeter(this.targetPlan.length - 1)
      } else {
        // 添加定向
        const defaultParams = deepCopy(defaulTargetParams)
        let targetingParam = deepCopy(this.curTarget)
        targetingParam = Object.assign(deepCopy(this.originData), defaultParams, targetingParam)
        this.targetPlan.push({
          targetingId: '',
          targetingName: `定向包${len + 1}`,
          targetingParam: deepCopy(targetingParam)
        })
        this.setTargeter(this.targetPlan.length - 1)
      }
    },
    targetNameChange(val) {
      const targetPlan = this.targetPlan.filter((ret) => ret.check).pop()
      this.$set(targetPlan, 'targetingName', val)
    },
    selectAudience(data, originData, target, includes, excludes) {
      const delKeys = ['population', 'exclude_population', 'paid_audience']
      delKeys.forEach((key) => target[key] && delete target[key])
      if (isArray(data)) {
        data.forEach((ret) => {
          includes = ret.audienceData.filter((met) => met.select === 'include').map((ret) => ret.id)
          excludes = ret.audienceData.filter((met) => met.select === 'exclude').map((ret) => ret.id)
        })
      }
      const { audiences } = originData

      audiences.forEach((ret) => {
        const selectFunc = (audienceData) => {
          audienceData.map((met) => {
            const include = includes.includes(met.id)
            const exclude = excludes.includes(met.id)
            let select = ''
            if (include) select = 'include'
            else if (exclude) select = 'exclude'
            if (select) this.$set(met, 'select', select)
          })
        }
        if (!ret.audienceData) {
          getPopulationList({ ad_account_id: ret.account_id }).then((audienceData) => {
            if (isArray(audienceData)) {
              const data = audienceData.map((ret) => {
                return {
                  id: ret.orientation_id,
                  key: ret.orientation_id,
                  vaule: ret.orientation_name,
                  name: ret.orientation_name,
                  extend: ret.cover_num,
                  type: ret.population_type
                }
              })
              this.$set(ret, 'audienceData', data)
              selectFunc(ret.audienceData)
            }
          })
        } else selectFunc(ret.audienceData)
      })
      this.$set(target, 'audienceData', audiences[0].audienceData)
    },
    convertSysTargetParams(target) {
      const {
        intelli_extend_option,
        region,
        age,
        app_interest_ids,
        app_ids,
        population,
        exclude_population,
        paid_audience,
        behavior_interest
      } = target

      this.$set(target, 'intelli_extend_option', Number(intelli_extend_option)) // 智能定向

      // 性别/Android版本/iOS版本/网络环境/设备品牌/设备价格__直接覆盖

      target.ageMode = age && Object.keys(age).length > 0 ? 'CUSTOM' : 'NONE'
      target.ageMode === 'CUSTOM' && (target.age = [age.min, age.max])
      target.district = region && region.length ? 'CITY' : 'NONE'
      target.audienceMode = isArray(population) || isArray(exclude_population) || isArray(paid_audience) ? 'AUDIENCE' : 'NONE'
      if (target.district === 'CITY') this.decompile(region, target.cityData)
      // app行为
      if (isArray(app_interest_ids)) {
        target.app_behavior = 1
        this.decompile(app_interest_ids, target.appData)
      } else if (isArray(app_ids)) {
        target.app_behavior = 2
        target.mult_cate = app_ids.map((ret) => {
          return {
            id: ret,
            name: ret
          }
        })
      }
      // 人群包
      if (target.audienceMode === 'AUDIENCE') {
        // 设置所有账号的人群包
        const includes = []
        isArray(population) && includes.push(...population)
        isArray(paid_audience) && includes.push(...paid_audience)
        this.selectAudience(null, { audiences: target.audiences }, target, includes, exclude_population || [])
      }
      // 行为兴趣
      const { behavior, interest } = behavior_interest || {}
      if (behavior || interest) target.behavior_type = 1
      if (behavior) {
        const { keyword, label, time_type, strength_type, scene_type } = behavior
        if (isArray(keyword) && keyword.length) {
          target.action_tags.push(
            ...keyword.map((ret) => {
              return {
                id: ret.id,
                name: ret.name,
                num: '未知',
                type: 'KEYWORD'
              }
            })
          )
        }
        if (isArray(label) && label.length) {
          target.action_tags.push(
            ...label.map((ret) => {
              return {
                id: ret,
                name: ret,
                type: 'CATEGORY'
              }
            })
          )
        }
        target.action_days = time_type
        target.action_intensity = strength_type
        target.action_scene = scene_type
      }
      if (interest) {
        const { label } = interest
        if (isArray(label) && label.length) {
          target.word_tags.push(
            ...label.map((ret) => {
              return {
                id: ret,
                name: ret,
                type: 'CATEGORY'
              }
            })
          )
        }
      }
    },
    decompile(Ids, data) {
      const deepSelect = (item) => {
        item.forEach((ret) => {
          if (ret && ret.children && ret.children.length) deepSelect(ret.children)
          this.$set(ret, 'check', true)
        })
      }
      if (isArray(Ids) && Ids.length) {
        Ids.forEach((ret) => {
          const item = getKeyOfData(data, 'id', ret)
          deepSelect([item])
        })
      }
    }
  }
}
